export default class GroupRent {
    constructor() {
        this.id = "";
        this.name = "";
    }
    update(data) {
        this.id = data.id;
        this.name = data.name;
    }
}